// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_sw-0";